"use client";

import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@yardzen/ui/components/button";
import { Spinner } from "@yardzen/ui/components/spinner";
import { useFormStatus } from "react-dom";

export function SubmitButton({
  disabled,
  questionKey,
}: {
  disabled?: boolean;
  questionKey: string;
}) {
  const { pending } = useFormStatus();

  return (
    <Button
      className="w-1/2 flex-1"
      endIcon={
        pending ? (
          <Spinner className="size-4" />
        ) : (
          <FontAwesomeIcon icon={faArrowRight} />
        )
      }
      type="submit"
      disabled={pending || disabled}
    >
      Next
    </Button>
  );
}
